export default __webpack_public_path__ + "static/media/0014.dcee5e6e.png";